import Grow from "@avinet/adaptive-ui-core/layout/Grow";
import Row from "@avinet/adaptive-ui-core/layout/Row";
import { useTranslate } from "@avinet/adaptive-ui-translate";
import { WizardFormTree } from "../../../hooks/useWizardFormTree";
import { Icon } from "../../Icon";
import SectionDisplayRenderer from "../SectionDisplayRenderer";

const WizardSummaryRenderer = ({
  tree,
  onPrev,
}: {
  tree: WizardFormTree[];
  onPrev?: () => void;
}) => {
  const t = useTranslate("Form");
  return (
    <>
      <div className="wizard-page-content wizard-summary">
        <h2>{t("summary")}</h2>
        <p>{t("summaryInfo")}</p>
        {tree.map((entry, idx) => {
          if (entry.type === "section") {
            return (
              <SectionDisplayRenderer
                key={entry.children[0].idx}
                section={entry.children[0].section}
              />
            );
          }
          const group = entry.children
            .filter((entry) => !entry.section.type.startsWith("display_"))
            ?.map((entry) => {
              return (
                <SectionDisplayRenderer
                  key={entry.idx}
                  section={entry.section}
                />
              );
            });
          return group.length > 0 ? (
            <span key={"g" + idx}>
              {!!entry.group?.title && <h3>{entry.group.title}</h3>}
              {group}
            </span>
          ) : null;
        })}
      </div>
      <Row className="btn-group">
        {onPrev && (
          <button type="button" className="btn" onClick={onPrev}>
            <Icon name="chevron" rotate={180} /> {t("prev")}
          </button>
        )}
        <Grow />
        <button type="submit" className="btn">
          <Icon name="checkmark" /> {t("submit")}
        </button>
      </Row>
    </>
  );
};

export default WizardSummaryRenderer;
